
const navbar = document.getElementById('navbar');
let isScrolled = false;
let bubbleTimer;

const cta_button = document.getElementById('cta_button');

cta_button.addEventListener('click', () => {
  const eventName = cta_button.dataset.mixpanelEvent;
  console.log(eventName);
  if (eventName) {
    posthog.capture(`marmeto_navbar_cta_book_demo_clicked_${eventName}`);
  }
});

function bubble() {
  const b = document.createElement('div');
  b.className = 'bubble';
  const size = Math.random() * 50 + 30;
  b.style.width = b.style.height = size + 'px';
  b.style.left = Math.random() * 100 + '%';
  b.style.setProperty('--x', (Math.random() - 0.5) * 120 + 'px');
  navbar.appendChild(b);
  setTimeout(() => b.remove(), 4000);
}

document.querySelectorAll('.mobile-menu-link').forEach(link => {
  const parentItem = link.closest('.mobile-menu-item');
  const hasChildren = link.dataset.hasChildren;

  if (hasChildren) {
    link.addEventListener('click', e => {
      e.preventDefault();

      // close other open menus
      document
        .querySelectorAll('.mobile-menu-item.open')
        .forEach(item => {
          if (item !== parentItem) item.classList.remove('open');
        });

      parentItem.classList.toggle('open');
    });
  }
});


window.addEventListener('scroll', () => {
  if (window.scrollY > 100 && !isScrolled) {
    navbar.classList.add('scrolled');
    isScrolled = true;

    bubbleTimer = setInterval(bubble, 320);
    setTimeout(() => clearInterval(bubbleTimer), 1600);
  }

  if (window.scrollY <= 100 && isScrolled) {
    navbar.classList.remove('scrolled');
    isScrolled = false;
    clearInterval(bubbleTimer);
  }
});

const mobileBtn = document.getElementById('mobileMenuBtn');
const mobileMenu = document.getElementById('mobileMenu');
const mobileClose = document.getElementById('mobileClose');
const mobileOverlay = document.getElementById('mobileOverlay');

/* Get all links inside mobile menu */
const mobileLinks = mobileMenu.querySelectorAll('a');

function openMobileMenu() {
  mobileMenu.classList.add('open');
  mobileOverlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeMobileMenu() {
  mobileMenu.classList.remove('open');
  mobileOverlay.classList.remove('active');
  document.body.style.overflow = '';
}

/* Click hamburger → open */
mobileBtn.addEventListener('click', openMobileMenu);

/* Click X → close */
mobileClose.addEventListener('click', closeMobileMenu);

/* Click outside (overlay) → close */
mobileOverlay.addEventListener('click', closeMobileMenu);

/*  Click any menu link → close */
mobileLinks.forEach(link => {
  link.addEventListener('click', e => {
    // If link has children, DO NOT close the menu
    if (link.dataset.hasChildren === 'true') {
      e.preventDefault();
      return;
    }

    // Otherwise, close mobile menu
    closeMobileMenu();
  });
})


